<template>
  <div>
    <div class="zone"></div>
    <div id="fix" class="head fixheader">
      <div class="container">
        <div class="logo" style="float: left;line-height: 140px;"><img src="../assets/img/logo-head.png" style="width:100%;height:auto;"></div>
        <div class="nav">
          <el-menu :default-active="activeIndexs" class="el-menu-demo" mode="horizontal" @select="handleSelects">
            <el-menu-item index="/">首 页</el-menu-item>
            <el-menu-item index="/about">公司简介</el-menu-item>
            <el-menu-item index="/history">公司历程</el-menu-item>
            <el-submenu index="/news">
              <template slot="title">新闻中心</template>
              <el-menu-item index="/news">最新动态</el-menu-item>
              <el-menu-item index="/cooper">企校合作</el-menu-item>
            </el-submenu>
            <el-menu-item index="/organ">公司机构</el-menu-item>
            <el-menu-item index="/case">成功案例</el-menu-item>
            <el-menu-item index="/honor">公司荣誉</el-menu-item>
            <el-menu-item index="/recruit">诚聘英才</el-menu-item>
            <el-menu-item index="/contact">联系我们</el-menu-item>
          </el-menu>
          <div class="menu">
            <el-button @click="drawer = true" icon="el-icon-s-fold" class="rbtn">
            </el-button>
          </div>
          <el-drawer title="河北国超信息科技有限公司" :visible.sync="drawer" :direction="direction">
            <div class="fixed-title">
              <el-link @click="toPath('/')">首页</el-link>
            </div>
            <div class="fixed-title">
              <el-link @click="toPath('/about')">公司简介</el-link>
            </div>
            <div class="fixed-title">
              <el-link @click="toPath('/history')">公司历程</el-link>
            </div>
            <div class="fixed-title">
              <el-link @click="toPath('/news')">最新动态</el-link>
            </div>
            <div class="fixed-title">
              <el-link @click="toPath('/cooper')">企校合作</el-link>
            </div>
            <div class="fixed-title">
              <el-link @click="toPath('/organ')">公司机构</el-link>
            </div>
            <div class="fixed-title">
              <el-link @click="toPath('/case')">成功案例</el-link>
            </div>
            <div class="fixed-title">
              <el-link @click="toPath('/honor')">公司荣誉</el-link>
            </div>
            <div class="fixed-title">
              <el-link @click="toPath('/recruit')">诚聘英才</el-link>
            </div>
            <div class="fixed-title">
              <el-link @click="toPath('/contact')">联系我们</el-link>
            </div>
          </el-drawer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        scroll: '',
        activeIndex: '1',
        activeIndex2: '1',
        drawer: false,
        direction: 'rtl',
        visible: false,
        activeIndexs: this.$route.path
      }
    },
    methods: {
      handleSelects(key, keyPath) {
        this.$router.push(key);
      },
      menu() {
        this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
        var fix = document.getElementById("fix");
        if (this.scroll >= 183) {
          fix.classList.add('fixheader-scroll');
        } else {
          fix.classList.remove('fixheader-scroll');
        }
      },
      toPath(callback) {
        this.$router.push({
          path: callback
        })
      }
    },
    mounted() {
      window.addEventListener('scroll', this.menu)
    }
  }
</script>

<style>
  #fix li.el-submenu .el-submenu__title {
    height: 80px;
    line-height: 100px;
    color: #303133;
    font-weight: bolder;
    font-size: 16px !important;
    background-color: transparent !important;
    padding: 0 5px !important;
  }

  #fix li.el-submenu .el-submenu__title .el-submenu__icon-arrow {
    display: none !important;
  }

  #fix .el-menu--horizontal > .el-submenu.is-active .el-submenu__title{
    border:0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Fixheader.vue